import React from 'react';
import Header from "../components/Header/Header";
import bg from '../assets/img/joinBG.jpg'
import OpenPositions from "../components/JoinOurTeam/OpenPositions";
import CheckBack from "../components/JoinOurTeam/CheckBack";
import JobModal from "../components/Modals/JobModal";

class JoinOurTeam extends React.Component {
    state = {
        jobModalOpen: false,
        jobSelected: ""
    };

    handleClick = (id) => {
        this.setState({
            jobModalOpen: true,
            jobSelected: id
        })
    };

    handleClose = () => {
        this.setState({
            jobModalOpen: false
        })
    };

    render() {
        const {jobModalOpen, jobSelected} = this.state;
        const openPositions = this.props.data.job.edges.map(i => {
            const {
                id,
                acf: {
                    department,
                    job_description,
                    location,
                    position,
                    email
                }
            } = i.node;
            return {
                id,
                department,
                job_description,
                location,
                position,
                email
            }
        });
        const selectedJob = openPositions.filter(i => {
            return i.id === jobSelected
        });
        const {header} = this.props.data.headerText.edges[0].node.acf;
        return (
          <div>
              <Header title={header} bg={bg}/>
              <OpenPositions
                onClick={(id) => this.handleClick(id)}
                jobData={openPositions}
              />
              {
                  jobModalOpen && (
                    <JobModal
                      isOpen={jobModalOpen}
                      close={() => this.handleClose()}
                      jobData={selectedJob[0]}
                    />
                  )
              }
              <CheckBack/>
          </div>
        );
    }
}

export default JoinOurTeam;

export const jobQuery = graphql`
  query jobQuery {
    job: allWordpressPost(filter: {acf: {type: {eq: "job posting"}}}){
        edges{
            node{
                id
                acf{
                    position
                    location
                    department
                    job_description
                    email
                }
            }
        }
    }
      headerText: allWordpressPage(filter: {wordpress_id: {eq: 637}}) {
          edges {
              node {
                  acf {
                      header
                  }
              }
          }
      }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/join-our-team.js